import makeStyles from "@mui/styles/makeStyles";

const Styles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  container: {
    display: "flex",
    width: 351,
    flexDirection: "column",
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBlock: 26,
  },
  content: {
    marginTop: 21,
    marginBottom: 18,
  },
  bbLogo: {
    width: 66,
    height: 66,
  },
  opbLogo: {
    width: 110,
    height: 21,
  },
  bold: {
    fontWeight: 500,
  },
  button: {
    fontFamily: "BancoDoBrasil Textos",
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}));

export default Styles;
